module.exports = ".category-button{\r\n\tcursor: pointer;\r\n}\r\n.category-button:hover{\r\n\tbackground-color: #ddd;\r\n}"